<template>
  <div class="bg_gray">
    <Header navTitle="我的订单" navPath="/mobile/center"></Header>
    <van-tabs
      v-model:active="tabActiveName"
      color="#009dd9"
      title-active-color="#00ADEF"
      line-width="60"
      class="tab_common">
      <van-tab title="课程订单" name="curriculum">
        <LoadList :pager="orderList.pager"
                  v-model:loading="loading_data"
                  v-model:finished="finished"
                  @getPager="getPager">
        <OrderRecordList :orderList="orderList" v-if="tabActiveName=='curriculum'"
                           :cmdPayDisabled="orderList.cmd_pay_disabled"
                           :cmdDelDisabled="orderList.cmd_del_disabled"
                           @notifyBatchBtn="notifyBatchBtn"
                           @cur-detail-handler="goCurDetail"
                           @get-pager-handler="getPager"
                           @order-command-handler="handleCommandOrder"
                           @selection-change-handler="selectionChangeHandler"
                           @count-down-end-handler="countDownEnd"
                           @pay-order-handler="payOrderHandler"
                           @cancel-order-handler="cancelOrderHandler"
                           @delete-order-handler="deleteOrderHandler"></OrderRecordList>

          </LoadList>

      </van-tab>
      <van-tab title="会员卡订单" name="vip">

        <LoadList :pager="orderList.pager"
                  v-model:loading="loading_data"
                  v-model:finished="finished"
                  @getPager="getPager">

        <OrderRecordList :orderList="orderList" v-if="tabActiveName=='vip'"
                           :cmdPayDisabled="orderList.cmd_pay_disabled"
                           :cmdDelDisabled="orderList.cmd_del_disabled"
                           @notifyBatchBtn="notifyBatchBtn"
                           emptyDesc="暂无会员卡订单"
                           @get-pager-handler="getPager"
                           @order-command-handler="handleCommandOrder"
                           @selection-change-handler="selectionChangeHandler"
                           @count-down-end-handler="countDownEnd"
                           @pay-order-handler="payOrderHandler"
                           @cancel-order-handler="cancelOrderHandler"
                           @delete-order-handler="deleteOrderHandler"></OrderRecordList>

        </LoadList>

      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  import Header from 'components/mobile/common/Header'
  import OrderRecordList from 'views/mobile/center/include/OrderRecordList'
  import LoadList from "components/mobile/common/LoadList"

  import {listOrder, cancelOrder, closeOrder, deleteOrder, fmtUserOrderInfo} from 'api/settlement/order/user'
  import {preparePayment} from 'api/settlement/payment/user'
  import {db_time_to_local_fmt} from 'utils/timeutils'
  import { tableConfigBase, getPagerOffsetLimit } from 'utils/common'
  import { showConfirmMessageBox, showMessage, showNotify } from 'api/base/mobile/message'
  import { ElMessage } from 'element-plus'
  export default {
    components: {
      Header,
      OrderRecordList,
      LoadList
    },
    data() {
      return {
        first_loading: true,
        loading_data: false,
        finished: false,
        tabActiveName: 'curriculum',
        orderList: {
          data:[],
          selectedRows:[],
          cmd_pay_disabled: true,
          cmd_del_disabled: true,
          pager: {
            currentPage: 0,
            pageSize: 10,
            total: 0,
          }
        },
      }
    },
    created() {
      this.$emit('update:isShowHeader', false);
      this.loadOrderList(true);
    },
    methods: {
      async loadOrderList(clear_list=false){

        if (this.loading_data){
            return false;
        }

        let pager_offset_limit = getPagerOffsetLimit(this.orderList.pager);
        let filter_data = {
          type: this.tabActiveName,
        };

        filter_data.offset = pager_offset_limit['offset'];
        filter_data.limit = pager_offset_limit['limit'];

        console.log(this.filter_data);

        const that = this;
        this.loading_data = true;

        if (this.first_loading){
            this.$emit('update:isShowOverlay', true);
            this.first_loading = false;
        }

        await listOrder(filter_data).then(result => {

          if (result.succeed) {

            if (clear_list) {
              this.orderList.data = [];
            }

            result.data.forEach(item=>{
                let filled_item = fmtUserOrderInfo(item);

                if (filled_item.state_text === '待支付' && filled_item.cancel_seconds < 0){
                    filled_item.state_text = '已关闭';
                }

                this.orderList.data.push(filled_item);
            });

            this.orderList.pager.total = result.count;

            this.orderList.cmd_del_disabled = true;
            that.notifyMutiPayBtn();

          } else {

            switch (result.error_code) {
              case -9999 : {
                this.goPath(`/mobile/login/?next=/mobile/center/order`);
              }
                break;
              default: {
                showMessage(result.error_msg)
              }
                break;
            }

          }

          this.loading_data = false;

          this.$emit('update:isShowOverlay', false);

        }).catch(err => {
          showMessage(err)
          // that.$alert(`${err}`, '提示', {
          //   confirmButtonText: '确定'
          // });

          this.$emit('update:isShowOverlay', false);
        });

      },
      goPath(path) {
        this.$router.push(path);
      },
      getPager(pager) { //获取分页变化后数据
        console.log(pager);
        this.loadOrderList();
      },
      handleCommandOrder(command) {  //批量操作

        let selected_order_uuids = [];

        this.orderList.selectedRows.forEach(item => {
          selected_order_uuids.push(item.uuid);
        });

        if (selected_order_uuids.length > 0){

          switch (command) {
            case 'pay': { //合并支付

              preparePayment(selected_order_uuids).then(result=>{

                if (result.succeed) {
                    this.goPath(`/mobile/order/pay/mixed/${result.confirm_key}`);
                } else {
                  showMessage(result.error_msg);
                }

              }).catch(err=>{
                  showMessage(err);
              })

            } break;
            case 'del': { //批量删除订单
              this.deleteOrderByUUIDS(selected_order_uuids);
            } break;
          }

        }

      },
      goCurDetail(cur_uuid){
        const cur_detail_page = this.$router.resolve({name: 'CourseDetail', params: {uuid: cur_uuid}});
        window.open(cur_detail_page.href, '_blank');
      },
      selectionChangeHandler(selectedRows) {
        console.log('selectionChangeHandler',selectedRows);
        this.orderList.selectedRows = selectedRows
      },

      notifyMutiPayBtn(){

        let unpay_count = 0;

        this.orderList.selectedRows.forEach(item=>{

            if(item.state === 1){
                unpay_count += 1;
            }

        });

        if (unpay_count > 0) {
          this.orderList.cmd_pay_disabled = false;
        } else {
          this.orderList.cmd_pay_disabled = true;
        }

      },

      countDownEnd(order_item) {

        console.log('time end', order_item.order_sn);

        const that = this;
        closeOrder({'uuid_in': [order_item.uuid]}).then(result => {

          if (result.succeed) {
            showNotify(`订单 ${order_item.order_sn} 已经超过24小时未支付,系统已自动关闭订单`, 'success')
            // ElMessage({
            //   dangerouslyUseHTMLString: true,
            //   message: `<p>订单<strong>${order_item.order_sn}</strong>已经超过24小时未支付,系统已自动关闭订单`
            // });

            that.loadOrderList(true);

          } else {
            showMessage(result.error_msg)
            // that.$alert(`${result.error_msg}`, '提示', {
            //   confirmButtonText: '确定'
            // });
          }

        }).catch(err => {
          showMessage(err)
          // that.$alert(`${err}`, '提示', {
          //   confirmButtonText: '确定'
          // });
        });

      },
      payOrderHandler(order_uuid){
         this.goPath(`/mobile/order/pay/${order_uuid}/?from=order_center`);
      },
      async cancelOrderHandler(order_uuid){

        const that = this;

        showConfirmMessageBox('确定要取消该订单吗?').then(() => {
          cancelOrder({'uuid_in': [order_uuid]}).then(result => {

            if (result.succeed) {

              that.loadOrderList(true);

            } else {
              showMessage(result.error_msg)
              // that.$alert(`${result.error_msg}`, '提示', {
              //   confirmButtonText: '确定'
              // });
            }

          }).catch(err => {
            showMessage(err)
            // that.$alert(`${err}`, '提示', {
            //   confirmButtonText: '确定'
            // });
          });
        }).catch(()=>{});

      },
      deleteOrderHandler(order_uuid){
          this.deleteOrderByUUIDS([order_uuid]);
      },
      deleteOrderByUUIDS(uuid_list){

        let confirm_msg = uuid_list.length > 1 ? '确定要删除选中的订单吗?' : '确定要删除该订单吗?';

        showConfirmMessageBox(confirm_msg).then(() => {

            deleteOrder({ 'uuid_in': uuid_list})
              .then(result=>{
                  if(result.succeed){
                      this.orderList.pager.currentPage = 1;
                      this.finished = false;
                      this.loadOrderList(true);
                  } else {
                      showMessage(result.error_msg);
                  }
              })
              .catch(err=>{
                  showMessage(err);
              })

        }).catch(()=>{});
      },
      notifyBatchBtn(val, btn_command){

          switch(btn_command){
            case 'pay': {
                this.orderList.cmd_pay_disabled = val;
            } break;
            case 'delete': {
                this.orderList.cmd_del_disabled = val;
            } break;
          }

      }
    },
    watch: {
        tabActiveName(val){
           this.orderList.pager.total = 0 ;
           this.orderList.pager.currentPage = 1 ;
           this.finished = false;
           this.first_loading = true;
           this.loadOrderList(true);
        }
    }
  }
</script>

<style lang="scss" scoped>
  .info_sm {
    font-size:12px;
    display:flex;
    margin-bottom:20px;
    span {
      flex: 1;
    }
  }
</style>
